import { Card, Stack, Typography, Skeleton } from "@mui/material";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { tokens } from "src/locales/tokens";

import { InstagramProfile } from "src/types/analysis";

interface InstagramProfileEngagementRateCardProps {
  account?: InstagramProfile;
}

export const InstagramProfileEngagementRateCard: FC<
  InstagramProfileEngagementRateCardProps
> = (props) => {
  const { account } = props;
  const { t } = useTranslation();

  return (
    <>
      <Card
        sx={{
          alignItems: "center",
          bgcolor: "var(--mui-palette-primary-main)",
          color: "var(--mui-palette-primary-contrastText)",
          display: "flex",
          justifyContent: "space-between",
          height: "100%",
        }}
      >
        <Stack
          spacing={1}
          justifyContent={"center"}
          alignContent={"center"}
          alignItems={"center"}
          p={3}
          sx={{
            width: "100%",
          }}
        >
          <Typography
            color="inherit"
            variant="overline"
            textAlign="center"
          >
            {t(tokens.instagram.profile.engagementRate)}
          </Typography>
          {account && (
            <Typography
              color="inherit"
              variant="h1"
              textAlign="center"
            >
              {account.data.engagementRate.toFixed(2)}%
            </Typography>
          )}
          {!account && (
            <Skeleton
              width={50}
              height={80}
            />
          )}
        </Stack>
      </Card>
    </>
  );
};
